import { render } from "./ReportVacancy.vue?vue&type=template&id=01805c30&scoped=true"
import script from "./ReportVacancy.vue?vue&type=script&lang=js"
export * from "./ReportVacancy.vue?vue&type=script&lang=js"

import "./ReportVacancy.vue?vue&type=style&index=0&id=01805c30&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01805c30"]])

export default __exports__